import Colors from "@src/constants/Colors";

export const initialNotificationFilterTypes = [
  { key: 1, value: "Discounts", isSelected: true },
  { key: 2, value: "Voids", isSelected: true },
  { key: 3, value: "Tips", isSelected: true },
];

export const TAB_TYPE = {
  ALL: 1,
  UNREAD: 2,
  SUMMARY: 3,
};

export const CHECK_TYPE = {
  DISCOUNT: "1",
  VOID: "2",
  TIP: "3",
};

export const TabStyle = {
  ".MuiTabs-fixed": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  ".MuiTabs-root": {
    padding: "5px 8px",
    gap: "10px",
    border: `1px solid ${Colors.neutralwhite}`,
    boxShadow: Colors.Elevation_3,
  },
  ".MuiTabs-flexContainer": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: Colors.white,
    padding: "7px 8px",
    borderRadius: "8px",
  },
  ".MuiTabs-indicator": {
    display: "none",
  },
  ".MuiTabs-flexContainer > .Mui-selected": {
    background: Colors.primary_700,
    borderRadius: "8px",
    color: Colors.white,
  },
  ".MuiTab-root": {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    background: Colors.white,
    height: "100vh",
    maxHeight: "30px",
    padding: "3px 16px",
    minHeight: "24px",
    minWidth: 0,
    fontFamily: "Ringside Regular-Bold",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    textTransform: "capitalize",
  },
};

export const CustomFilterStyle = {
  padding: "0px",
  borderRadius: "8px",
  fontFamily: "Ringside Regular-Book",
  fontStyle: "normal",
  fontWeight: 325,
  fontSize: "14px",
  lineHeight: "20px",
  color: Colors.neutralblack,
  textAlign: "center",
};
